const Mock = require('mockjs');
const Random = Mock.Random;
const data = Mock.mock({
  err: 0,
  msg: "",
  ret: {
    "banners|3-5": [
      {
        "url|1": ['https://www.baidu.com', 'https://www.bing.com'],
        "pic|1": Random.dataImage("375x200", "375x200"),
        "openType|1": [1, 2, 3]
      },
    ],
    "menus|3-8": [
      {
        "url|1": ['https://www.baidu.com', 'https://www.bing.com'],
        "text|+1": ['Baidu', 'Bing', 'Google', 'yahoo'],
        "openType|1": [1, 2, 3]
      },
    ],
    "icons|3-8": [
      {
        "icon|1": Random.dataImage("40x40", "40x40"),
        "text|+1": ['院校', '专业', '热门'],
        "url|1": ['https://www.baidu.com', 'https://www.bing.com'],
        "openType|1": [1, 2, 3]
      },
    ],
    "livecard": {
      "title": "近期直播",
      "more": {
        "url|1": ['https://www.baidu.com', 'https://www.bing.com'],
        "text": "查看更多",
        "openType|1": [1, 2, 3],
      },
      "list|2-4": [
        {
          "tags": [
            {
              text: "免费",
              type: 'gold'
            }
          ],
          "title|+1": ["清华大学MBA", "北京大学MBA", "交通大学MBA"],
          pic: Random.dataImage("72x96", "72x96"),
          subTitle: "清华大学硕士导师庄唯敏在线解读",
          date: "今天19:00",
          "applyNum|200-2000": 100,
        },
      ]
    },
    classcard: {
      "title": "抢分计划",
      "more": {
        "url|1": ['https://www.baidu.com', 'https://www.bing.com'],
        "text": "查看更多",
        "openType|1": [1, 2, 3],
      },
      "list|2-4": [
        {
          "title|+1": ["清华大学MBA", "北京大学MBA", "交通大学MBA"],
          "pic": Random.dataImage("140x80", "140x80"),
          "originPrice|50-2000": 200,
          "price|0-1200": 100,
          "applyNum|200-2000": 100,
        },
      ]
    }
  }
});

module.exports = data;